import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../_metronic/layout";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "./_redux/Actions";
import { Pagination } from "../../../_metronic/_partials/controls";
import * as columnFormatters from "../../components/column-formatters";
import * as UIHelpers from "../../components/UIHelpers";
import { Formik, Field } from "formik";
import DropdownReactSelect from "../../components/DropdownReactSelect";
import helperFunc from "../../../_metronic/_helpers/helperFunc";
// import FilterComponent from "../../components/FilterComponent";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader,
  // CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import DateRangeFilterComponent from "../../components/DateRangeFilterComponent";
import { NotificationManager } from "react-notifications";
import moment from "moment";
export const initialFilter = {
  filter: {},
  q: "",
  sort: "desc", // asc||desc
  sortBy: "createdAt",
  skip: UIHelpers.skip,
  limit: UIHelpers.limit,
  page: UIHelpers.page,
  dateRange: undefined,
};

const JoiningListComponent = (props) => {
  const dispatch = useDispatch();
  const suhbeader = useSubheader();
  const [filter, setFilter] = useState(initialFilter);
  const [count, setCount] = useState(0);
  const [searchApply, setSearchApply] = useState(false);
  const [isFilterApply, setIsFilterApply] = useState(true);
  const [dateRange, setDateRange] = useState({
    from: moment().subtract(0, "days"),
    to: moment(),
  });
  suhbeader.setTitle("Html5 Games Joining List");
  suhbeader.setIsSearch(true);
  useEffect(() => {
    filter.q = suhbeader.searchText.q;
    setFilter(filter);
    setCount(count + 1);
  }, [suhbeader.searchText]);
  const [
    contestForSelectedDropdownFilterData,
    setContestForListDropdownFilterData,
  ] = useState([]);
  const [
    contestForDropdownFilterData,
    setContestForDropdownFilterData,
  ] = useState([]);

  const getHandlerTableChange = (type, data) => {
    if (type === "pagination") {
      filter.limit = data.sizePerPage;
      filter.skip = Math.abs(
        data.page ? data.sizePerPage - data.page * data.sizePerPage : 0
      );
      filter.page = data.page || 1;
      setFilter(filter);
      setCount(count + 1);
    }
    if (type === "sort") {
      filter.sort = data.sortOrder;
      filter.sortBy = data.sortField;
      setFilter(filter);
      setCount(count + 1);
    }
  };
  // const filterChange = (filterData) => {
  //     filter.q = filterData.q;
  //     filter.filter = filterData.filter;
  //     setFilter(filter);
  //     setCount(count + 1);
  // }

  const columns = [
    {
      dataField: "html5Game.html5Category.name",
      text: "Html5 Game Category",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "html5Game.name",
      text: "Html5 Game",
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "user.gamerjiName",
      text: "User name",
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "spendTime",
      text: "Spend Time",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (cell, row) => {
        console.log(row)
        var beginningTime = moment(row.startDate);
        var endTime = moment(row.updatedAt);
        console.log(beginningTime)
        console.log(endTime)
        var difftm = endTime.diff(beginningTime, 'seconds');
        return difftm;
      }
    },
    {
      dataField: "createdAt",
      text: "CreatedAt",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.DateColumnFormatter,
    },
  ];
  const { currentState } = useSelector(
    (state) => ({ currentState: state.H5Games }),
    shallowEqual
  );
  const {
    totalCount,
    entities,
    listLoading,
    companyDropdownList,
  } = currentState;

  const company = "";
  useEffect(() => {
    dispatch(actions.fetchCompanyDropdownList());
  }, []);
  useEffect(() => {
    if (companyDropdownList && companyDropdownList?.data) {
      // let temp = [{
      //   _id: 0,
      //   label: "All",
      //   value: "all",
      //   baseUrl: "all",
      // }];
      let temp = [];
      const userdata = JSON.parse(localStorage.getItem("userData"));
      const userCompany = userdata?.company || [];
      companyDropdownList.data.forEach((element, i) => {
        // console.log(userCompany.includes(element._id));
        // console.log(!helperFunc.isAdmin());
        // if (!helperFunc.isAdmin()) {
        if (userCompany.includes(element._id)) {
          temp.push({
            _id: i + 1,
            label: element.name,
            value: element._id,
            baseUrl: element.baseUrl,
            code: element.code,
            "data-tokens": element.name,
          });
        }
        // } else {
        //   temp.push({
        //     _id: i + 1,
        //     label: element.name,
        //     value: element._id,
        //     baseUrl: element.baseUrl,
        //     code: element.code,
        //     "data-tokens": element.name,
        //   });
        // }
      });
      setContestForDropdownFilterData(temp);
    }
  }, [companyDropdownList]);
  // useEffect(() => {
  //     if (!listLoading) {
  //         if (isFilterApply) {
  //             filter.dateRange = dateRange;
  //         }
  //         dispatch(actions.fetchJoiningList(filter));
  //     }
  // }, [count, dispatch]);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: UIHelpers.sizePerPageList,
    sizePerPage: filter.limit,
    page: filter.page,
  };

  // const applyFilter = (values, type) => {
  //     var tampFilter = { ...filter };
  //     if (type === 'isApply') {
  //         setIsFilterApply(values.target.checked);
  //         tampFilter.dateRange = undefined;
  //         setFilter(tampFilter);
  //         setCount(count + 1);
  //     } else {
  //         if (!values.dateRange) {
  //             NotificationManager.error('Please Select From Date and To Date', 'Error');
  //             return;
  //         }
  //         setDateRange(values.dateRange);
  //         tampFilter.dateRange = values.dateRange;
  //         setFilter(tampFilter);
  //         setCount(count + 1);
  //     }
  // }

  useEffect(() => {
    if (!listLoading) {
      if (isFilterApply) {
        filter.dateRange = dateRange;
      }
      // Create the payload including the Company-GJ value
      const newFilter = { ...filter };
      const payload = {
        ...newFilter, // Spread the properties of the newFilter object
        company: contestForSelectedDropdownFilterData?.code
      };
      console.log("company", contestForSelectedDropdownFilterData?.code)
      if (contestForSelectedDropdownFilterData?.code) {
        dispatch(actions.fetchJoiningList(payload));
      }
    }
  }, [count, dispatch]);
  const applyFilter = async (values) => {
    if (
      contestForSelectedDropdownFilterData == null ||
      contestForSelectedDropdownFilterData.length <= 0
    ) {
      NotificationManager.error("Please Select Company", "Error");
      return false;
    }

    setSearchApply(true);

    // Create a new filter object based on the current filter
    const newFilter = { ...filter };
    newFilter.company = contestForSelectedDropdownFilterData.code;

    if (values?.phoneEmail) {
      newFilter.search = {
        userID: values.phoneEmail,
      };
    }

    if (values?.dateRang) {
      newFilter.dateRange = values.dateRang;
      setDateRange(values.dateRang);
    }

    // Add the logic to update the selectedFields array with the selected fields

    // Set the updated filter state
    setFilter(newFilter);

    // Dispatch the action with the updated filter
    if (!listLoading) {
      // Create the payload including the Company-GJ value
      const payload = {
        ...newFilter, // Spread the properties of the newFilter object
        company: newFilter.company,
      };
      dispatch(actions.fetchJoiningList(payload));
    }
  };

  const createFormInputs = () => {
    return (
      <div
        className="report-filter-bLock border-0 row align-items-center"
        style={{ padding: "0px 0", margin: "0px", marginBottom: "40px" }}
      >
        <Formik
          initialValues={{}}
          onSubmit={(values) => {
            console.log("val::22", values);
            applyFilter(values);
          }}
        >
          {({ handleSubmit, values }) => (
            <div className="col-lg-12 col-md-12">
              {/* <div className="row m-0 p-0"> */}
              <form
                onSubmit={handleSubmit}
                className="form form-filter w-100"
                autoComplete="off"
                style={{ marginTop: "10px" }}
              >
                <div className="form-group row m-0 align-items-center z-index: 10">
                  <div
                    className="col-lg-3 col-md-4 z-index: 10 !important pl-0"
                    // style={{ maxWidth: "325px" }}
                  >
                    <label>Select Company</label>
                    <DropdownReactSelect
                      placeholder={"Company"}
                      name={"Company"}
                      value={contestForSelectedDropdownFilterData}
                      // isMulti={values.isShared == 'true' ? true : false}
                      isMulti={false}
                      isClearable={true}
                      isSearchable={true}
                      closeMenuOnSelect={true}
                      options={contestForDropdownFilterData}
                      onChange={setContestForListDropdownFilterData}
                    />
                  </div>
                  <div
                    className="col-lg-6 col-md-6 z-index: 10 !important pl-0"
                    style={{
                      // maxWidth: "500px",
                      marginTop: "15px",
                      marginLeft: "-25px",
                    }}
                  >
                    <DateRangeFilterComponent
                      dateRange={dateRange}
                      isFilterApply={isFilterApply}
                      applyFilter={applyFilter}
                    />
                  </div>
                  <div className="justify-content-end mx-2">
                    {/* <button
                          type="submit"
                          className="btn btn-dark"
                          style={{ width: "130px", marginTop: "20px" }}
                        >
                          Search
                        </button> */}
                  </div>
                </div>
              </form>
              {/* </div> */}
            </div>
          )}
        </Formik>
      </div>
    );
  };
  return (
    <>
      <Card>
        <CardHeader title="Html5 Games Joining List"></CardHeader>
        {createFormInputs()}

        {searchApply === true ? ( // searchApply === true
          entities?.length == 0 && listLoading === false ? (
            UIHelpers.dataTableNoData()
          ) : (
            <CardBody>
              <PaginationProvider
                pagination={paginationFactory(paginationOptions)}
              >
                {({ paginationProps, paginationTableProps }) => {
                  return (
                    <Pagination
                      isLoading={listLoading}
                      paginationProps={paginationProps}
                    >
                      <BootstrapTable
                        wrapperClasses="table-responsive"
                        bordered={false}
                        classes="table table-head-custom table-vertical-center overflow-hidden"
                        bootstrap4
                        remote
                        keyField="_id"
                        data={entities ? entities : []}
                        columns={columns}
                        onTableChange={getHandlerTableChange}
                        {...props}
                        {...paginationTableProps}
                      >
                        <PleaseWaitMessage entities={entities} />
                        <NoRecordsFoundMessage entities={entities} />
                      </BootstrapTable>
                    </Pagination>
                  );
                }}
              </PaginationProvider>
            </CardBody>
          )
        ) : (
          // <h4 className="text-center">Please select search</h4>
          ""
        )}
      </Card>
    </>
  );
};
export default JoiningListComponent;
